import { useSelector } from "react-redux";
import { RootState } from "store";
import { Auth } from "@spike/auth-model";

export const useAuth = (): Auth => {
	const auth = useSelector<RootState, Auth>(state => state.login.auth);
  return auth;
};

export default useAuth;